import { Repository } from '../../servics/httpsServics';

const controller = '/call';

export function getWaitingUserCount() {
  return Repository.get(controller + '/waiting-count', {});
}

export function getWaitingUser() {
  return Repository.get(controller + '/waiting-user', {});
}

export function initializeUserCall(data) {
  return Repository.post('/user-calls/initialize', data);
}
export function updateEndTs(data) {
  return Repository.put('/user-calls/updateEndTs', data);
}
export function endUserCall(data) {
  return Repository.post('/user-calls/end', data);
}

export function setReasonOfCall(data) {
  return Repository.post('/user-calls/reason', data);
}

export function getRoomByPeer(peer_id) {
  return Repository.get('/user-calls/getRoomByPeer', {
    params: { peer_id: peer_id }
  });
}
